import React  from 'react'
import PropTypes from 'prop-types'
import styles from './Wrapper.module.scss'

const Wrapper = ({
  children
}) => (
  <main className={styles.wrapper}>
    { children }
  </main>
)

Wrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired
}

export default Wrapper
